export default function pluralize(word: string, count: number | string, pluralForm?: string): string {
  const pluralized = pluralForm || `${word}s`;

  return Number(count) === 1 ? word : pluralized;
}
